<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Режим автосбора ключей</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="dialogAutoCollect" persistent max-width="450" content-class="dialog-border-radius">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Изменить режим автосбора ключей</v-card-title>
          <v-col cols="12" class="py-0">
            <v-switch
              v-model="autoCollect"
              inset
              :label="autoCollect ? 'Включен' : 'Выключен'"
              color="success"
            />
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="dialogAutoCollect = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              @click="updateAutoCollect"
              :loading="isloading"
            >
              Изменить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ToggleAutoKeyCollection',
  props: ['doorphones'],
  data () {
    return {
      isloading: false,
      dialogResult: false,
      autoCollect: false,
      dialogAutoCollect: false,
      updateResult: {},
    };
  },
  methods: {
    ...mapActions({
      setMassAutoKey: 'Doorphone/setMassAutoKey',
    }),
    updateAutoCollect () {
      const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });

      this.isloading = true;
      this.setMassAutoKey({
        toggle: this.autoCollect,
        doorphones: selectedDoorphoneId,
      })
        .then((res) => {
          this.toggle = false;
          this.dialogAutoCollect = false;
          this.updateResult = res;
          this.dialogResult = true;
        })
        .catch((error) => {
          this.$flash_warning('Не удалось изменить режим автосбора ключей');
          console.error(error);
        })
        .finally(() => {
          this.isloading = false;
        });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
